<template>
  <div>
    <page-header
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
      :page="headerPage"
      :actions="headerActions"
    />
    <add-book
      v-if="showAdd"
      class="mb-3"
      :subjects="filter.options.subjects"
      @cancel="onCancelAdd"
      @save="onSaveAdd"
    ></add-book>

    <filter-manager
      class="filter-manager_extended"
      search-container-class="search-btn"
      v-model="filter.model"
      :filters="filtersHeader"
      :displayAdvanced="false"
      @search="() => onSearchHandler()"
    />
    <custom-separator
      class="my-4 custom-separator"
      text="Resultados de Libros"
    />
    <div v-if="hasResults">
      <result-row v-for="(item, key) in results" :key="key" :item="item" />
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onSearchHandler"
      />
    </div>
    <custom-result-not-found
      v-else
      class="mt-4 row pt-3"
      text="No hay Información Disponible"
    />
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";

import AddBook from "./components/AddBook.vue";
import ResultRow from "./components/ResultRow.vue";

import academicService from "@/services/api/academicUtils.api.js";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";

import EduEspCode from "@/utils/constants/eduEspCode";

import storeMixin from "@/mixin/storeGenerator";
import alertMixin from "@/mixin/alert.mixin";

const MODULE_NAME = "InventoryCatalogBooks";
const DEFAULT_PAGE_SIZE = 10;

export default {
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    AddBook,
    ResultRow
  },
  mixins: [storeMixin, alertMixin],
  data() {
    return {
      moduleName: MODULE_NAME,
      showAdd: false,
      filter: {
        model: {
          subject: null,
          title: null
        },
        options: {
          subjects: []
        }
      },
      results: [],
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: DEFAULT_PAGE_SIZE
      }
    };
  },
  computed: {
    headerPage() {
      return {
        icon: "fas fa-book-open",
        title: "Catálogo de Libros",
        routes: ["Inicio", "Libros", "Catálogo de Libros"]
      };
    },
    headerActions() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left",
          variant: "outline-success",
          click: () => this.$router.go(-1)
        },
        {
          text: "Añadir Libro",
          icon: "fas fa-file-plus",
          variant: "success",
          click: () => (this.showAdd = true)
        }
      ];
    },
    filtersHeader() {
      return [
        {
          name: "subject",
          component: "CustomDropDown",
          options: this.filter.options.subjects,
          value: this.filter.model.subject,
          placeholder: "Materia",
          fieldName: "name",
          fieldKey: "id",
          class: "col-sm-6 col-md-5 ml-0 mr-0"
        },
        {
          name: "title",
          component: "CustomInput",
          placeholder: "Título del Libro",
          icon: "fa fa-search orange-icon",
          leftIcon: true,
          class: "col-sm-12 col-md-6 col-lg-7",
          type: "text"
        }
      ];
    },
    hasResults() {
      return Boolean(this.results.length);
    }
  },
  async mounted() {
    await Promise.allSettled([this.getSubjects(), this.onSearchHandler()]);
  },
  methods: {
    async getSubjects() {
      const { data } = await academicService.getEduEsp({
        codetype: EduEspCode.CatlibSubject
      });
      this.filter.options.subjects = data;
    },
    onCancelAdd() {
      this.showAdd = false;
    },
    async onSaveAdd({ name, subject }) {
      try {
        const payload = {
          name,
          subjectId: subject.id
        };
        await inventoryCatalogService.add(payload);
        this.showAdd = false;
        this.ShowToast("", "Libro añadido con éxito.", "success");
        this.onSearchHandler();
      } catch (error) {
        this.ShowToast("Error", error?.response?.data.message, "error");
      }
    },
    async onSearchHandler(page = 1) {
      const { title, subject } = this.filter.model;
      const { pageSize } = this.pagination;

      const { data } = await inventoryCatalogService.search({
        title,
        subjectId: subject?.id,
        currentPage: page,
        pageSize
      });

      this.results = data.data;

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count
      };
    }
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = ["inventory-catalog-books-management"];

    next(async vm => {
      if (persistRoutes.includes(from.name)) {
        vm.recoveryData();
        await vm.onSearchHandler();
      } else {
        vm.shouldRecovery = false;
      }
    });
  }
};
</script>

<style></style>
